const MissingInfoDisplayLevel = {
  NONE: "NONE",
  WARNING: "WARNING",
  ERROR: "ERROR",
} as const;

type MissingInfoDisplayLevel =
  (typeof MissingInfoDisplayLevel)[keyof typeof MissingInfoDisplayLevel];

export default MissingInfoDisplayLevel;
export type { MissingInfoDisplayLevel };
